<template>
  <div class="mylevel-root" :style="cssVars()">
    <div class="mylevel-main" :class="[baseInfo && baseInfo.currGrade ? 'level-on' : 'level-off']">
      <div class="custom-nav-block" :style="`paddingTop:${barHeight}px`">
        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
          <template #left>
            <div class="left-nav"></div>
            <span class="tit-left">{{ $t('lang.BaseCommon.k046') }}</span>
          </template>
        </van-nav-bar>
      </div>

      <div class="level-block">
        <!-- 徽章 -->
        <div v-if="baseInfo" :class="['level-img', baseInfo.currGrade > 0 ? 'top-level-on' : 'top-level-off']"></div>
        <div class="level-con">
          <!-- 等级 -->
          <!-- prettier-ignore -->
          <div class="level-text">
            {{ $t('lang.BaseCommon.k001') }}.<template v-if="baseInfo">{{ baseInfo.currGrade || 0 }}</template>
          </div>
          <!-- 进度条 -->
          <div class="progress-box">
            <div v-if="baseInfo" class="progress-level">
              <span>{{ $t('lang.BaseCommon.k001') }}.{{ baseInfo.currGrade }}</span>
              <span>{{ $t('lang.BaseCommon.k001') }}.{{ baseInfo.nextGrade }}</span>
            </div>
            <div v-if="baseInfo" class="progress-line">
              <van-progress class="progress-bar" track-color="#ebebeb" :show-pivot="false" :percentage="baseInfo.currPercent" stroke-width="4" />
            </div>
            <MyPLabel v-if="baseInfo" class="progress-tip" :str="$t('lang.MyLevel.k001')" :numsOption="[{ value: baseInfo.needCoins || '' }]"></MyPLabel>
          </div>
        </div>
      </div>

      <div class="level-body">
        <div class="privileges-block">
          <div class="block-title">{{ $t('lang.BaseCommon.k047') }}</div>

          <!-- 等级选择 -->
          <div v-if="baseInfo && baseInfo.gradeRules && baseInfo.gradeRules.length" class="level-number" ref="levelNumberContainer">
            <div v-for="(item, index) in baseInfo.gradeRules" :class="{ active: currentTab === index }" :ref="`levelItem${index}`" @click="handleTabClick(index, item)">
              {{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}
            </div>
          </div>

          <!-- 等级权益 -->
          <div v-if="currentCon && currentCon.length" class="level-pri-box">
            <div v-for="(item, index) in currentCon" :key="index" :class="['level-pri-item', currentTab === 0 ? 'item-off' : 'item-on']">
              <!-- 需要有颜色的变化 -->
              <div class="level-pri-img">
                <img :src="item.icon | imgPath" alt="" />
              </div>
              <div class="level-pri-text">
                <div class="tit">{{ item.title }}</div>
                <div class="con">{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="rule-block">
          <!-- 规则 -->
          <div class="block-title">{{ $t('lang.BaseCommon.k044') }}</div>
          <div class="block-tips">{{ $t('lang.MyLevel.k002') }}</div>
          <table v-if="baseInfo && baseInfo.gradeRules && baseInfo.gradeRules.length" class="table-box">
            <tr class="table-head">
              <th>{{ $t('lang.BaseCommon.k043') }}</th>
              <th>{{ $t('lang.BaseCommon.k029') }}</th>
            </tr>
            <!-- prettier-ignore -->
            <tr v-for="(item, index) in baseInfo.gradeRules" :key="index" class="table-item">
              <td>
                <div class="level-item" :class="[!item.grade ? 'level-off' : 'level-on']">
                  <!-- <div class="level-icon"></div> -->
                  <span class="level-txt">{{ $t('lang.BaseCommon.k002') }}.{{ item.grade }}</span>
                </div>
              </td>
              <td>{{ item.coins }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/MyLevel/z-style-cfg.js'

import { getUserLevelInfo } from '@/api/imee.js'

export default {
  mixins: [pageCssVars],
  data() {
    return {
      baseInfo: null,
      currentTab: -1,
      currentCon: []
    }
  },
  methods: {
    scrollToCenter(index) {
      const container = this.$refs.levelNumberContainer
      const targetElement = this.$refs[`levelItem${index}`][0]

      if (container && targetElement) {
        const containerWidth = container.offsetWidth
        const containerLeft = container.offsetLeft
        const targetLeft = targetElement.offsetLeft
        const targetWidth = targetElement.offsetWidth

        // 计算滚动位置使元素居中
        const scrollPosition = targetLeft - containerLeft + targetWidth / 2 - containerWidth / 2

        // 平滑滚动到目标位置
        container.scrollTo({
          left: scrollPosition,
          behavior: 'smooth'
        })
      }
    },
    handleTabClick(arg, item) {
      this.currentTab = arg

      const conList = item.privilegeTypes || []
      const resArr = []
      if (this.baseInfo && this.baseInfo.privileges && this.baseInfo.privileges.length) {
        conList.forEach((item) => {
          const tempObj = this.baseInfo.privileges.find((ele) => ele.privilegeType === item)
          if (tempObj) {
            resArr.push(tempObj)
          }
        })
      }
      this.currentCon = resArr

      this.$nextTick(() => {
        this.scrollToCenter(arg)
      })
    },
    init() {
      getUserLevelInfo().then((res) => {
        if (res && !res.error) {
          if (res) {
            if (res.gradeRules && res.gradeRules.length) {
              try {
                res.gradeRules = res.gradeRules.sort((a, b) => a.grade - b.grade)
                const currIndex = res.gradeRules.findIndex((item) => item.grade === res.currGrade)
                const nextIndex = currIndex + 1
                if (currIndex > -1 && nextIndex <= res.gradeRules.length - 1) {
                  res.nextGrade = res.gradeRules[nextIndex].grade
                  res.needCoins = res.gradeRules[nextIndex].coins - res.topUpCoins
                  res.currPercent = (res.gradeRules[currIndex].coins / (res.gradeRules[nextIndex].coins - res.gradeRules[currIndex].coins)) * 100
                }

                this.$nextTick(() => {
                  this.handleTabClick(currIndex, res.gradeRules[currIndex])
                })
              } catch (err) {
                console.log('try catch err:', err)
              }
            }
            this.baseInfo = res
          }
        }
      })
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="less">
.mylevel-root {
  width: 100vw;
  min-height: 100vh;
  background: var(--page-color01, #fafafa);

  .custom-nav-block {
    .left-nav {
      width: 24px;
      height: 24px;
      background: var(--back-arrow) left top / 100% auto no-repeat;
    }
  }

  .mylevel-main {
    width: 100%;
    min-height: 100vh;

    .level-block {
      position: relative;
      width: 343px;
      height: 146px;
      margin: 40px auto 0;
      padding: 20px 20px 12px 20px;
      border-radius: 8px;

      position: relative;
      .level-img {
        width: 110px;
        height: 110px;
        background-size: 100% 100%;
        position: absolute;
        top: -35px;
        right: 20px;
      }
      .level-con {
        position: relative;
        z-index: 10;
        width: 100%;
        .level-text {
          font-family: 'Roboto Condensed';
          font-size: 46px;
          font-style: normal;
          font-weight: 700;
          line-height: 56px;
        }
        .progress-box {
          width: 100%;
          margin-top: 10px;

          .progress-level {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            font-family: 'Roboto';
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
          }

          .progress-line {
            position: relative;
            width: 100%;
            height: 4px;
            .progress-bar {
              height: 4px;
              border-radius: 4px;
              .van-progress__portion {
                border-radius: 4px;
              }
            }
          }
          .progress-tip {
            margin-top: 8px;
            text-align: center;
            font-family: 'Roboto';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            .unique-coin-icon {
              width: 16px;
            }
          }
        }
      }
    }

    .level-body {
      width: 100%;
      border-top-left-radius: 24px;
      border-top-right-radius: 24px;
      background: var(--page-color02, #fafafa);
      margin-top: 8px;
      padding-top: 12px;
      padding-bottom: 24px;
      .privileges-block {
        width: 100%;
        padding: 12px 16px 0;

        .block-title {
          color: var(--page-color03, #202326);
          font-family: 'Roboto';
          font-size: 20px;
          font-style: normal;
          font-weight: bold;
          line-height: 28px;
        }
        .level-number {
          width: 328px;
          margin: 14px auto 12px;
          overflow-x: auto;
          white-space: nowrap;
          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }
          > div {
            display: inline-block;
            color: var(--page-color04, #8e9092);
            text-align: center;
            font-family: 'Roboto';
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px;
            padding: 4px;
            min-width: 58px;
          }
          .active {
            border-radius: 100px;
            background: var(--page-color05, #e3e4e5);
            color: var(--page-color06, #202326);
          }
        }

        .level-pri-box {
          width: 343px;
          min-height: 64px;
          padding: 10px;
          margin: 0 auto;

          .level-pri-item {
            display: flex;
            padding-bottom: 20px;
            .level-pri-img {
              width: 40px;
              height: 40px;
              border-radius: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              > img {
                width: 24px;
                height: 24px;
              }
            }
            .level-pri-text {
              flex: 1;
              margin: 0 8px;
              .tit {
                font-family: 'Roboto';
                font-size: 16px;
                font-style: normal;
                font-weight: bold;
                line-height: 24px;
              }
              .con {
                font-family: 'Roboto';
                font-size: 12px;
                font-style: normal;
                font-weight: normal;
                line-height: 18px;
              }
            }
          }

          .item-off {
            .level-pri-img {
              background-color: var(--page-color07, #f0f1f2);
            }
            .level-pri-text {
              .tit {
                color: var(--page-color08, #353a3f);
              }
              .con {
                color: var(--page-color09, #5f656a);
              }
            }
          }

          .item-on {
            .level-pri-img {
              background-color: var(--page-color10, #fff4d6);
            }
            .level-pri-text {
              .tit {
                color: var(--page-color11, #733406);
              }
              .con {
                color: var(--page-color12, #ffa433);
              }
            }
          }
        }
      }

      .rule-block {
        width: 100%;
        padding: 12px 16px 0;

        .block-title {
          color: var(--page-color13, #202326);
          font-family: 'Roboto';
          font-size: 20px;
          font-style: normal;
          font-weight: bold;
          line-height: 28px;
        }

        .block-tips {
          color: var(--page-color14, #5f656a);
          font-family: 'Roboto';
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 18px;
        }

        .table-box {
          width: 100%;
          margin: 0 auto;
          margin-top: 10px;
          border-radius: 8px;
          background: var(--page-color15, #f0f1f2);
          overflow: hidden;
          .table-head {
            width: 100%;
            font-size: 15px;
            color: #333333;
            display: flex;
            background: var(--page-color16, #e3e4e5);
            th {
              height: 37px;
              color: var(--page-color17, #353a3f);
              text-align: center;
              font-family: 'Roboto';
              font-size: 14px;
              font-style: normal;
              font-weight: bold;
              line-height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;

              &:nth-child(1) {
                width: 120px;
              }
              &:nth-child(2) {
                flex: 1;
                border-left: 1px solid var(--page-color18, #f0f1f2);
                > img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }

          .table-item {
            width: 100%;
            font-size: 15px;
            color: #333333;
            display: flex;
            background: var(--page-color19, #f2f4f7);
            td {
              height: 37px;
              color: var(--page-color20, #000);
              font-style: normal;
              line-height: 28px;
              font-weight: 500;
              display: flex;
              align-items: center;
              justify-content: center;

              &:nth-child(1) {
                width: 120px;
                font-family: 'Roboto';
                font-size: 14px;
              }
              &:nth-child(2) {
                font-family: 'Roboto Condensed';
                font-size: 18px;
                border-left: 1px solid var(--page-color21, #f0f1f2);
                border-top: 1px solid var(--page-color21, #f0f1f2);
                flex: 1;
                > img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
            .level-item {
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 2px;
              // .level-icon {
              //   width: 16px;
              //   height: 16px;
              // }
              .level-txt {
                font-family: 'Roboto Condensed';
                font-size: 12px;
                font-style: normal;
                font-weight: 500;
                line-height: 16px;
                padding: 0 8px;
              }
            }
            .level-off {
              color: var(--page-color23, #8e9092);
              // border: 1px solid var(--page-color24, #e3e4e5);
              background: var(--page-color25, #e3e4e5);
              .level-icon {
                background: var(--icon-level-off) top left / 100% auto no-repeat;
              }
            }
            .level-on {
              color: var(--page-color26, #ffa433);
              // border: 1px solid var(--page-color27, #ffb94d);
              background: var(--page-color28, #fff4d6);
              .level-icon {
                background: var(--icon-level-on) top left / 100% auto no-repeat;
              }
            }
          }
        }
      }
    }
  }

  .top-level-on {
    background: var(--icon-level1) left top / 100% 100% no-repeat;
  }
  .top-level-off {
    background: var(--icon-level0) left top / 100% 100% no-repeat;
  }

  .mylevel-main.level-off {
    background: var(--icon-topbg-off) left top / 100% auto no-repeat;

    .custom-nav-block {
      background: var(--page-color29, #fafafa) var(--icon-topbg-off) left top / 100% auto no-repeat;
    }

    .level-block {
      background: var(--page-color30, #e3e4e5);
      .level-con {
        .level-text {
          color: var(--page-color31, #202326);
        }
        .progress-box {
          .progress-level {
            color: var(--page-color32, #5f656a);
          }

          .progress-line {
            .progress-bar {
              background: var(--page-color33, #d7d7d8) !important;
              .van-progress__portion {
                background: var(--page-color34, #5f656a) !important;
              }
            }
          }
          .progress-tip {
            color: var(--page-color35, #202326);
          }
        }
      }
    }
  }

  .mylevel-main.level-on {
    background: var(--icon-topbg-on) left top / 100% auto no-repeat;

    .custom-nav-block {
      background: var(--page-color36, #fafafa) var(--icon-topbg-on) left top / 100% auto no-repeat;
    }

    .level-block {
      border: 1px solid var(--page-color37, #ffffff);
      background: var(--level-block-background);
      .level-con {
        .level-text {
          color: var(--page-color38, #202326);
        }
        .progress-box {
          .progress-level {
            color: var(--page-color39, #5f656a);
          }

          .progress-line {
            .progress-bar {
              background: var(--page-color40, #fff4d6) !important;
              .van-progress__portion {
                background: var(--van-progress__portion-background) !important;
              }
            }
          }
          .progress-tip {
            color: var(--page-color41, #202326);
          }
        }
      }
    }
  }

  .van-nav-bar__left .tit-left {
    padding: 0 16px;
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .mylevel-root {
    .mylevel-main {
      .level-block {
        .level-img {
          right: unset;
          left: 20px;
        }
      }
    }
  }
}
</style>
